import type { HelpFile } from '../../types/help'
import { AutoAssignRuleRequestsTestIds } from '../../../testids/AutoAssignRuleRequestsTestIds'

export const autoAssignRuleRequestsHelp: HelpFile = {
  docPage: '/docs/governance/auto-assign-rules',
  texts: {
    [AutoAssignRuleRequestsTestIds.autoAssignRuleRequestsList]:
      'Regelanfragen sind Änderungsvorschläge für Auto-Zuweisungsregeln — erstellen, bearbeiten und reichen Sie Regeln zur Genehmigung ein, bevor sie in Kraft treten.',
    [AutoAssignRuleRequestsTestIds.btnCreateRequest]:
      'Öffnet den Assistenten zum Vorschlagen einer neuen Auto-Zuweisungsregel.',
    [AutoAssignRuleRequestsTestIds.colRequestType]:
      'Ob die Anfrage eine Auto-Zuweisungsregel erstellt, bearbeitet oder entfernt.',
  },
}
